import { useFeedbackDraftStore } from "@asurion-core/expert-workspace-feedback";
import { useNotification } from "@expert/common-ui";
import { useCallback } from "react";

export const useFeedbackNotification = () => {
    const notification = useNotification();

    // Read the draft at call time instead of subscribing, so the caller does not re-render on every keystroke
    return useCallback(
        (type: "success" | "error") => {
            if (type === "success" && useFeedbackDraftStore.getState().draft.description) {
                notification.success("Feedback saved");
            } else if (type === "error") {
                notification.error("Oops, there was an issue sending feedback. Try again—we saved your progress.");
            }
        },
        [notification],
    );
};
